<template>
  <tr class="table__row">
    <td class="table__cell table__cell--medium h-left-align">{{ item.family }}</td>
    <td class="table__cell table__cell--medium h-left-align">{{ item.product }}</td>
    <td class="table__cell table__cell--medium h-center-align">{{ item.item_number }}</td>
    <td class="table__cell table__cell--medium h-center-align">{{ item.tier }}</td>
    <td class="table__cell table__cell--medium h-center-align">{{ item.warranty }}</td>
    <td class="table__cell table__cell--medium h-center-align">${{ item.list_price }}</td>
    <td class="table__cell table__cell--action h-center-align">
      <span v-if="item.hasOwnProperty('fuel_member_price')">${{ item.fuel_member_price }}</span>
      <span v-else></span>
    </td>
  </tr>
</template>

<script>
  export default {
    props: ['item'],
  }
</script>
